import {
  call,
  fork,
  actionChannel,
  take,
  race,
  flush,
} from 'redux-saga/effects'
import { buffers } from 'redux-saga'

function delay(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

/**
 * @param {number} ms
 * @param {string} action Redux action type for the channel
 * @param {GeneratorFunction} task Saga invoked per action
 * @param {{ onTimeout?: (action: object) => Generator }} [options]
 *        If `race` loses to `delay(ms)`, `task` is cancelled; optional `onTimeout`
 *        runs with the same action (e.g. navigate when save exceeds `ms`).
 */
export function throttleAction(ms, action, task, options = {}) {
  const { onTimeout } = options

  return fork(function* () {
    const throttleChannel = yield actionChannel(action, buffers.sliding(1))

    while (true) {
      const actionToRun = yield take(throttleChannel)
      let raceResult = {}
      try {
        raceResult = yield race({
          taskResult: call(task, actionToRun),
          timeout: call(delay, ms),
        })
      } catch (e) {
        console.warn('error', e)
      }

      if ('taskResult' in raceResult) {
        /* const discarded = */ yield flush(throttleChannel)
      } else if ('timeout' in raceResult) {
        if (window.localStorage.getItem('assessmentLastTime')) {
          window.localStorage.setItem('assessmentLastTime', Date.now())
        }
        if (typeof onTimeout === 'function') {
          yield call(onTimeout, actionToRun)
        }
      }
    }
  })
}
